import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Skills from "./pages/Skills";
import Navbar from "./Components/Navbar";
import { useState } from "react";
import { projectData } from "./data";
import Experience from "./pages/Experience";

function App() {
  const [currentTechStack, setCurrentTechStack] = useState("React");
  const [currentProjects, setCurrentProjects] = useState(
    projectData[currentTechStack]
  );

  return (
    <div className="">
      <Navbar></Navbar>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/projects"
          element={
            <Projects
              currentTechStack={currentTechStack}
              setCurrentTechStack={setCurrentTechStack}
              currentProjects={currentProjects}
              setCurrentProjects={setCurrentProjects}
            />
          }
        />
        <Route path="/contact" element={<Contact />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/experience" element={<Experience />} />
      </Routes>
    </div>
  );
}

export default App;
